import { defineNuxtPlugin } from '#app';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

/**
 * Named so a plugin that has something to say during boot can depend on it (`plugins/hooks.ts`).
 *
 * The container registers its event-bus listeners in `beforeMount`, and vue-toastification's
 * `EventBus.emit` walks a handler list that is empty until then: a toast raised before this plugin
 * has run is dropped, not queued, and nothing replays it afterwards.
 *
 * Nuxt matches `dependsOn` against this name and silently ignores a name that matches no plugin, so
 * renaming it would reinstate that bug with no error anywhere — `tests/boot-toast-order.spec.ts`
 * pins it.
 */
export default defineNuxtPlugin({
    name: 'toast',
    setup(nuxtApp) {
        nuxtApp.vueApp.use(Toast);
    },
});
